export default[
    {
        path: 'photo/upload',
        name: 'photo-upload',
        component: () => import('@/views/photo-upload/Index'),
        meta: {
            step: 2,
        }
    },
]